import { Endpoint } from "../config";

export type CMSEndpointType =
  | "cmsContent"
  | "cmsContentArchive"
  | "cmsPageList";

export const cmsEndpoints: Record<CMSEndpointType, Endpoint> = {
  cmsContent: {
    url: "cms-page/",
  },
  cmsContentArchive: {
    url: "cms-page",
  },
  cmsPageList: {
    url: "cms-page-list/",
  },
};
